import React from 'react';
import { rem } from 'polished';
import moment from 'moment';
import { Button } from 'oxyrion-ui/lib';
import styled from 'styled-components';
import { __, formatPrice, formatDate } from '../../../../Utils';
import { connect, actions } from '../../../../Store';
import BaseList from '../../BaseList';
import IconTd from '../../../../Components/ReusableComponents/IconTd';
import CatalogCheckbox from '../../../ProductCatalog/Components/CatalogCheckbox';
import API2 from '../../../../API2';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const CheckAllLabel = styled.div`
  font-size: ${rem(8)};
`;
const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const Space = styled.div`
  width: ${rem(12)};
  height: ${rem(12)};
`;

class Quotes extends BaseList {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      actualYear: new Date().getFullYear(),
      title: __('Cenové ponuky'),
      notFoundMessage: __('Momentálne nemáte žiadne cenové ponuky'),
      isProduct: true,
      showPager: false,
      quotesToOpen: [],
    };

    actions.setActiveMenuItem('43');
  }

  componentDidMount() {
    this.init();
  }

  init() {
    const { actualPage, offset, nextOffset, total } = this.loadActualData();

    let newCheckedFilter = [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        loading: true,
        defaultSearchText: this.props.match.params.q,
        searchText: this.props.match.params.q,
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        await this.fetchFilter(
          !newCheckedFilter || newCheckedFilter.length === 0,
        );
        await this.fetchData();
        this.setTableHeight();
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    try {
      const { searchText, sorter } = this.state;
      this.setState({ showProductAddedPopup: false });
      const params = parameters;

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      if (sorter) {
        params.sorter = sorter;
      }

      params.status = 'approved';

      const newData = await API2.getB2BPriceOffersAction(params);

      this.setState({
        tableItems: newData.items,
        loading: false,
        yearLoading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
      this.setState({ loading: false });
    } catch (e) {
      console.log(e);
      this.setState({ error: __('Nepodarilo sa cenové ponuky') });
    }
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = s;

    if (newSorter === sorter) {
      newSorter = `-${s}`;
    }

    this.setState({ sorter: newSorter }, () => this.fetchData());
  }

  setTableHeight() {
    if (this.pager && this.mainWrapper && this.segment) {
      const tableHeight = window.innerHeight - 600;

      this.setState({ tableHeight });
    }
  }

  createColumns(sorter) {
    const { quotesToOpen, tableItems } = this.state;
    const result = [
      {
        accessor: 'number',
        Header: () => (
          <IconTd
            onClick={() => this.handleSorter('number')}
            sorter={sorter === 'number' || sorter === '-number' ? sorter : null}
          >
            {__('Číslo ponuky')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>{props.value}</P>
          );
        },
      },
      {
        accessor: 'project_name',
        Header: () => (
          <IconTd
            onClick={() => this.handleSorter('project_name')}
            sorter={
              sorter === 'project_name' || sorter === '-project_name'
                ? sorter
                : null
            }
          >
            {__('Názov projektu')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>{props.value}</P>
          );
        },
      },
      {
        accessor: 'totalOfferPrice',
        Header: () => <IconTd>{__('Suma bez DPH')}</IconTd>,
        maxWidth: 180,
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>
              {formatPrice(props.value.price)}
            </P>
          );
        },
      },
      {
        accessor: 'totalOfferPrice',
        Header: () => <IconTd>{__('Suma s DPH')}</IconTd>,
        maxWidth: 180,
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>
              {formatPrice(props.value.price_vat)}
            </P>
          );
        },
      },
      {
        accessor: 'valid_from',
        maxWidth: 120,
        Header: () => (
          <IconTd
            onClick={() => this.handleSorter('valid_from')}
            sorter={
              sorter === 'valid_from' || sorter === '-valid_from'
                ? sorter
                : null
            }
          >
            {__('Platnosť od')}
          </IconTd>
        ),
        Cell: props => {
          return <P>{formatDate(moment(props.value))}</P>;
        },
      },
      {
        accessor: 'valid_to',
        maxWidth: 120,
        Header: () => (
          <IconTd
            onClick={() => this.handleSorter('valid_to')}
            sorter={
              sorter === 'valid_to' || sorter === '-valid_to' ? sorter : null
            }
          >
            {__('Platnosť do')}
          </IconTd>
        ),
        Cell: props => {
          return <P>{formatDate(moment(props.value))}</P>;
        },
      },
      {
        accessor: '_id',
        maxWidth: 100,
        Header: () => (
          <CheckboxWrapper onClick={() => this.openAllQuotes()}>
            <CatalogCheckbox
              checked={quotesToOpen.length === tableItems.length}
            />
            <CheckAllLabel>{__('Označiť všetky')}</CheckAllLabel>
          </CheckboxWrapper>
        ),
        Cell: props => {
          const isIn = quotesToOpen.indexOf(props.value) > -1;
          return (
            <P
              style={{
                alignItems: 'center',
                justifyContent: 'center',
              }}
              s
              onClick={() => this.handleQuotesToOpen(props.value, isIn)}
            >
              <CatalogCheckbox checked={isIn} />
            </P>
          );
        },
      },
    ];

    return result;
  }

  onTdClicked(rowIndex) {
    const { tableItems } = this.state;
    if (tableItems[rowIndex]) {
      const id = tableItems[rowIndex]._id;

      this.props.history.push({
        pathname: `../shop/quotes/detail`,

        state: { ids: [id] },
      });
    }
  }

  openSelectedQuotes(ids) {
    this.props.history.push({
      pathname: `../shop/quotes/detail`,
      state: { ids },
    });
  }

  openAllQuotes() {
    const { tableItems } = this.state;

    let quotesToOpen = tableItems.map(t => t._id);

    if (this.state.quotesToOpen.length === tableItems.length) {
      quotesToOpen = [];
    }

    this.setState({
      quotesToOpen,
    });
  }

  handleQuotesToOpen(id, isIn) {
    const { quotesToOpen } = this.state;

    if (!isIn) {
      quotesToOpen.push(id);
    } else {
      quotesToOpen.splice(quotesToOpen.indexOf(id), 1);
    }

    this.setState({ quotesToOpen });
  }

  renderCustomBottomContent() {
    const { quotesToOpen } = this.state;
    return quotesToOpen.length > 0 ? (
      <ButtonWrapper>
        <Button
          small
          primary
          onClick={() => this.openSelectedQuotes(quotesToOpen)}
        >
          {__('Zobraziť označené')}
        </Button>
        <Space />
      </ButtonWrapper>
    ) : (
      <div />
    );
  }

  render() {
    return <React.Fragment>{super.render()}</React.Fragment>;
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Quotes);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Quotes/List/index.jsx